import React, { useEffect, useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Link, useParams } from "react-router-dom";
import { Collapse, UncontrolledCollapse } from "reactstrap";
// Import Data
import navdata from "../LayoutMenuData";
//i18n
import withRouter from "../../Components/Common/withRouter";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import classnames from 'classnames';
import icon from "../../assets/images/brands/betsson-menubar.png";
import { useLocation } from "react-router-dom";
import country from "../../common/country";
import { setBrandPath, setClientPath, setMarketPath } from "../../slices/auth/menu/thunk";
import { setAnalyticsMenubar, setBreadcrumb } from "../../slices/auth/menu/reducer";
import { sortAlphabetically } from "../../slices/helper";
import { getAllLibrariesSuccess, setAllLibrariesFirstLoad, setAllLibrariesHasMore, setAllLibrariesLoaded, setAllLibrariesLoading, setAllLibrariesPage } from "../../slices/campaigns/reducer";
import { getFeedSuccess, setFeedsFirstLoad, setFeedsHasMore, setFeedsLoading, setFeedsPage } from "../../slices/feeds/reducer";
import { resetTableFilter } from "../../slices/folder/thunk";
/**
 * React component representing the vertical layout.
 * @component
 * @param {Object} props - Component properties.
 * @param {Object} props.router - React router object containing location information.
 * @param {string} props.layoutType - Type of the layout ('vertical', 'semibox', etc.).
 * @param {string} props.leftsidbarSizeType - Type of the left sidebar size.
 * @param {string} props.sidebarVisibilitytype - Type of sidebar visibility ('show', 'hide', etc.).
 * @returns {JSX.Element} - React element representing the vertical layout component.
*/
const VerticalLayout = (props) => {
	const navData = navdata().props.children;
	const path = props.router.location.pathname;
	const params = useParams();
	const dispatch = useDispatch();
	const location = useLocation();

	/**
	 * Selector function to extract the layout state from the Redux state.
	 * @function
	 * @param {Object} state - Redux state object.
	 * @returns {Object} - Layout state object.
	 */
	const selectStates = createSelector(state => state, state => ({
		leftsidbarSizeType: state.Layout.leftsidbarSizeType,
		sidebarVisibilitytype: state.Layout.sidebarVisibilitytype,
		layoutType: state.Layout.layoutType,
		brandPath: state.MenuData.brandPath,
		marketPath: state.MenuData.marketPath,
		permission: state.Permission.permission,
		company: state.MenuData.client
	}));
	const {
		leftsidbarSizeType, sidebarVisibilitytype, layoutType, brandPath, marketPath, permission, company
	} = useSelector(selectStates);
	
	const [menuData, setMenuData] = useState([]);
	const [showMarkets, setShowMarkets] = useState(true);

	/**
	 * Function to dynamically adjust the sidebar menu based on the window size.
	 * @function
	 * @returns {void}
	*/
	const resizeSidebarMenu = useCallback(() => {
		var windowSize = document.documentElement.clientWidth;
		var hamburgerIcon = document.querySelector(".hamburger-icon");
		if (windowSize >= 1025) {
			if (document.documentElement.getAttribute("data-layout") === "vertical") {
				document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
			}
			if (document.documentElement.getAttribute("data-layout") === "semibox") {
				document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
			}
			if ((sidebarVisibilitytype === "show" || layoutType === "vertical" || layoutType === "twocolumn") && document.querySelector(".hamburger-icon")) {
				if (hamburgerIcon !== null) {
					hamburgerIcon.classList.remove("open");
				}
			} else {
				if (hamburgerIcon !== null) {
					hamburgerIcon.classList.add("open");
				}
			}

		} else if (windowSize < 1025 && windowSize > 767) {
			document.body.classList.remove("twocolumn-panel");
			if (document.documentElement.getAttribute("data-layout") === "vertical") {
				document.documentElement.setAttribute("data-sidebar-size", "sm");
			}
			if (document.documentElement.getAttribute("data-layout") === "semibox") {
				document.documentElement.setAttribute("data-sidebar-size", "sm");
			}
			if (document.querySelector(".hamburger-icon")) {
				document.querySelector(".hamburger-icon").classList.add("open");
			}
		} else if (windowSize <= 767) {
			document.body.classList.remove("vertical-sidebar-enable");
			if (document.documentElement.getAttribute("data-layout") !== "horizontal") {
				document.documentElement.setAttribute("data-sidebar-size", "lg");
			}
			if (document.querySelector(".hamburger-icon")) {
				document.querySelector(".hamburger-icon").classList.add("open");
			}
		}
	}, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

	useEffect(() => {
		if (window.location.pathname.includes('analytics')) {
			filterMenuForAnalytics();
		} else {
			setMenuData(navData);
		}
	}, [navData, location]);

	useEffect(() => {
		window.addEventListener("resize", resizeSidebarMenu, true);
	}, [resizeSidebarMenu]);

	useEffect(() => {
		// window.scrollTo({ top: 0, behavior: "smooth" });
		/**
		 * Function to initialize the navigation menu based on the current path.
		 * Scrolls to the top, removes activation, and activates the corresponding menu item.
		 * @function
		 * @returns {void}
		*/
		const initMenu = () => {
			if (params.brand) {
				const ul = document.getElementById("navbar-nav");
				const items = ul.getElementsByClassName('menu-link-brand');
				let itemsArray = [...items]; // converts NodeList to Array			
				itemsArray.forEach((item, idx) => {
					if (item.id === params.brand) {
						item.classList.add('active');
						if (showMarkets) {
							toggleCollapse(item.nextElementSibling);
							item.parentElement.classList.add('show');
						}
						if (params.market && showMarkets) {
							const subItems = item.nextElementSibling.getElementsByClassName('menu-link-market');
							const subItemsArr = [...subItems];
							subItemsArr.forEach((subItem, subIdx) => {
								if (subItem.id === params.market) {
									subItem.classList.add('active');
								} else {
									subItem.classList.remove('active');
								}
							})
						} else {
							const showMarket = marketHandler();
							if (showMarket) {
								const allSubItems = document.getElementsByClassName('menu-link-market');
								const subItemsArr = [...allSubItems];
								if (subItemsArr) {
									subItemsArr.forEach((subItem) => {
										subItem.classList.remove('active');
									});
								}
							}
						}
					} else {
						item.classList.remove('active');
						item.parentElement.classList.remove('show');
					}
				})	
			}
		};
		if (props.layoutType === "vertical") {
			initMenu();
		}
	}, [brandPath, marketPath, props.layoutType, menuData, params]);

	useEffect(() => {
		marketHandler();
	}, [params]);

	useEffect(() => {
		setTimeout(() => {
			const foundNavItem = document.querySelector(`#${params.brand}`);
			if (foundNavItem) {
				foundNavItem.classList.add('active');
				const showMarket = marketHandler();
				if (showMarket) {
					toggleCollapse(foundNavItem.nextElementSibling);
					foundNavItem.parentElement.classList.add('show');
					const foundMarketItem = foundNavItem.querySelector(`#${params.market}`);
					if (foundMarketItem) {
						foundMarketItem.classList.add('active');
					}
				}
			}
		}, 1);
	}, []);

	function filterMenuForAnalytics() {
		if (navData.length > 0) {
			const filteredNavData = [];
			let i = 0;
			do {
				const client = navData[i];
				if (permission['clients'][client._id].permissionsWK.includes('campaignAnalyze')) {
					const filteredBrandData = [];
					let k = 0;
					do {
						const brand = client.brands[k];
						console.log('brand', brand);
						if (brand && permission['brands'][brand._id].permissionsWK.includes('campaignAnalyze')) {
							const filteredMarketData = [];
							let m = 0;
							do {
								const market = brand.markets[m];
								if (market && permission['markets'][market._id].permissionsWK.includes('campaignAnalyze')) {
									filteredMarketData.push(market);
								}
								m++;
							} while (m < brand.markets.length);
							filteredBrandData.push({...brand, markets: filteredMarketData});
						}
						k++;
					} while (k < client.brands.length);
					filteredNavData.push({...client, brands: filteredBrandData});
				}
				i++;
			} while (i < navData.length);	
			setMenuData(filteredNavData);
			dispatch(setAnalyticsMenubar({ ...company, clients: filteredNavData}));
		}
	}

	function marketHandler() {
		if (window.location.href && (window.location.href.includes('feeds') || window.location.href.includes('fonts'))) {
			setShowMarkets(false);
			return false;
		} else {
			setShowMarkets(true);
			return true;
		}
	}


	function useRemainingPath() {
		const paramNames = Object.keys(params);
		let remainingPath = path;
		paramNames.forEach(paramName => {
			remainingPath = remainingPath.replace(`/${params[paramName]}`, '');
		});
		remainingPath = remainingPath.replace(/^\/|\/$/g, '')
		if (remainingPath.includes('/')) {
			remainingPath = remainingPath.split('/')[0]
		}
		if (remainingPath.includes('settings')) {
			return 'campaigns/filter/all';
		} else {
			return remainingPath;
		}
	}

	function addMarketFlag(market) {
		let foundCountry = country.find(item => item.name === market).flagImg;
		if (foundCountry) {
			return (
				<img src={foundCountry} className="me-2 rounded-circle" width="15" height="15" />
			)
		} else {
			return null
		}
	}

	function changePath(e, client = null, brand = null, market = null) {
		if (!e.target.className.includes('form-nested-select')) {
			if (client) {
				dispatch(setClientPath(client._id));
			}
			if (brand) {
				dispatch(setBrandPath(brand._id));
			}
			if (market) {
				dispatch(setMarketPath(market._id));
			}
			dispatch(resetTableFilter());
			dispatch(setBreadcrumb({ pageTitle: '', title: [] }));
		}
	}

	function rotateTogglerIcon(e) {
		e.preventDefault();
		const selectAllNavItem = document.querySelectorAll('.nav-item');
		selectAllNavItem.forEach(item => item.classList.remove('show'));
		if (e.target.parentElement.parentElement.classList.contains('show')) {
			e.target.parentElement.parentElement.classList.remove('show');
		} else {
			e.target.parentElement.parentElement.classList.add('show');
		}
		const collapse = e.target.parentElement.parentElement.querySelector('.menu-dropdown');
		toggleCollapse(collapse, true)
	}

	function toggleCollapse(collapse, fromClick = false) {
		const allMenuDropdown = document.querySelectorAll('.menu-dropdown');
		allMenuDropdown.forEach(item => {
			if (item.parentElement.children[0].id !== collapse.parentElement.children[0].id) {
				item.style.maxHeight = null;
				item.classList.remove('active');
				item.classList.remove('show');
			}
		})
		if (fromClick) {
			if (collapse.classList.contains('show')) {
				collapse.style.maxHeight = null;
			} else {
				collapse.style.maxHeight = collapse.scrollHeight + 'px';
			}
		} else {
			collapse.style.maxHeight = collapse.scrollHeight + 'px';
		}
		if (collapse.classList.contains('active')) {
			collapse.classList.remove('active');
			collapse.classList.remove('show');
			collapse.parentElement.classList.remove('show');
		} else {
			collapse.classList.add('active');
			collapse.classList.add('show');
			collapse.parentElement.classList.add('show');
		}

	}
	return (
		<React.Fragment>
			{params ? menuData && sortAlphabetically(menuData, 'clientName').map((client, clientKey) => {
				return (
					<div className="nav-client-wrapper" key={clientKey}>
						<li className="menu-title"><span data-key="t-menu">{client.clientName}</span></li>
						{client.brands && sortAlphabetically(client.brands, 'name').map((brand, brandKey) => {
							return (
								<li className="nav-item" key={brandKey}>
									<Link
										to={`/${client.clientName.toLowerCase().replaceAll(/\s+/g, "-")}/
										${brand.name.toLowerCase().replaceAll(/\s+/g, "-")}/
										${useRemainingPath()}`}
										onClick={(e) => changePath(e, client, brand)}
										className={('nav-link menu-link menu-link-brand ')}
										id={brand.name.toLowerCase().replaceAll(/\s+/g, "-")}
									// data-bs-toggle="collapse"
									>
										{brand?.logo && brand.logo !== '' ?
											<img className="menubar-icon" src={brand.logo} />
											: <p className="menubar-icon m-0">{brand.name.slice(0, 1).toUpperCase()}</p>}
										<span className="w-100" data-key="t-apps">{brand.name}</span>
										{showMarkets ?
											<div
												data-bs-toggle="collapse"
												className="form-nested-select"
												id={brand.name.toLowerCase().replaceAll(/\s+/g, "-") + '-' + brandKey}
												onClick={rotateTogglerIcon}
											></div>
											: null}
									</Link>
									{showMarkets ?
										<React.Fragment>
											<div className="menu-dropdown">
												<ul className="nav nav-sm flex-column">
													{showMarkets && Array.isArray(brand.markets) ? sortAlphabetically(brand.markets, 'name').map((market, marketKey) => {
														return (
															<li className="nav-item" key={marketKey} >
																<Link
																	to={`/${client.clientName.toLowerCase().replaceAll(/\s+/g, "-")}/
															${brand.name.toLowerCase().replaceAll(/\s+/g, "-")}/
															${market.name.toLowerCase().replaceAll(/\s+/g, "-")}/
															${useRemainingPath()}`}
																	onClick={(e) => changePath(e, client, brand, market)}
																	className={("nav-link menu-link-market")}
																	id={market.name.toLowerCase().replaceAll(/\s+/g, "-")}
																>
																	<span data-key="t-apps">
																		{addMarketFlag(market.name)}
																		{market.name}
																	</span>
																</Link>
															</li>
														)
													}) : null}
												</ul>
											</div>
										</React.Fragment>
										: null}
								</li>
							)
						})}
					</div>
				)
			}) : null}
		</React.Fragment>
	);
};

VerticalLayout.propTypes = {
	location: PropTypes.object,
	t: PropTypes.any,
};

export default withRouter(VerticalLayout);